// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"55": "1eda41222aade879","668": "33cb1f5a30d5875b","671": "d7d2766ce8ccfdab","8": "a60b98699396ff83","856": "44fda186dada8e26",}[chunkId] + ".js"
}